import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { UseTypeFontSize } from '../../../../common/hooks/useTypeFontSize'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { SelectCustom } from '../../../../common/selectCustom'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { LayoutPanel } from '../../../common/html/LayoutPanel'
import { LinkComponent } from '../../../common/html/LinkComponent'
import { TitleComponent } from '../../../common/html/TitleComponent'
import { NUMBER_ITEM_TABLE } from '../../interested/constant'
import { TYPE_REPORTS, TYPE_REPORTS_SELECT } from '../constant'
import classes from '../index.module.scss'
import {
  changeHeightItem,
  changeTypeReport,
  getLoadingReport,
  resetStore,
  selectDataReport,
  selectTypeReport,
} from '../store/slice'
import { getReports } from '../store/thunk'

export const LatestReports = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const ref = useRef()
  const typeFontSize = UseTypeFontSize()

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectDataReport)
  const typeReport = useSelector(selectTypeReport)
  const loadingReport = useSelector(getLoadingReport('getReports'))

  //Actions
  const handleSelectTypeReport = (value) => {
    dispatch(changeTypeReport(value))
  }
  const actionViewAll = () => {
    navigate(COMPONENTS.dashboard.components.latestReports.route)
  }

  //useEffect
  useEffect(() => {
    dispatch(
      getReports({
        ReportType: typeReport.value,
        PageSize: 10,
      }),
    )
  }, [typeReport.value, locale])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    if (ref?.current) {
      dispatch(changeHeightItem(ref?.current?.clientHeight / NUMBER_ITEM_TABLE))
    }
  }, [data?.length, typeFontSize, locale])

  return (
    <>
      <LayoutPanel>
        {loadingReport && <Loading />}
        <div
          className="wh100 flexColumn"
          style={{
            opacity: loadingReport ? 0 : 1,
          }}
        >
          <div className="dFlex justifyContentBetween alignItemsCenter">
            <TitleComponent title="dashboard.latestReport.latestReport" />
            <div onClick={actionViewAll}>
              <Translate
                value="dashboard.latestReport.viewAll"
                className="cursorPointer"
                style={{
                  color: '#2C73E8',
                }}
              />
            </div>
          </div>
          <div>
            <SelectCustom
              activeItem={typeReport}
              data={Object.values(TYPE_REPORTS_SELECT)}
              chooseItem={handleSelectTypeReport}
              style={{ marginBottom: 12 }}
              isI18n
            />
          </div>
          <div className={classes.listItemReport} ref={ref}>
            {!data.length ? (
              <Notification />
            ) : (
              <>
                {data.map((item) => (
                  <ItemLatestReport
                    key={item?.reportId}
                    item={item}
                    typeReport={item?.reportTypeId}
                  />
                ))}
              </>
            )}
          </div>
        </div>
      </LayoutPanel>
    </>
  )
}

export const ItemLatestReport = ({ item, typeReport }) => {
  return (
    <LinkComponent
      href={
        typeReport === TYPE_REPORTS_SELECT[TYPE_REPORTS.BUSINESS].id
          ? `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${item?.organizationId}&isOrderBl=true`
          : item?.sourceUrl
      }
      style={{ height: '100%' }}
    >
      <Element
        className="h100 dFlex alignItemsCenter"
        style={{
          color: '#2C73E8',
        }}
      >
        <TextEllipsisStaticLine
          text={item.title}
          isI18n={false}
          lineClamp={1}
        />
      </Element>
    </LinkComponent>
  )
}
